module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/3-7f998b0ddeb62183e36bb95a294ea721.jpg";